import { NavLink } from 'react-router-dom';
import { Home, Compass, MessageSquare, Info, LogIn, User } from 'lucide-react';
import { useSession } from '@/lib/auth-client';

const navItems = [
  { to: '/home', icon: Home, label: 'Home' },
  { to: '/discover', icon: Compass, label: 'Discover' },
  { to: '/dms', icon: MessageSquare, label: 'Messages' },
  { to: '/about', icon: Info, label: 'About' },
];

export function BottomNav() {
  const { data: session } = useSession();

  return (
    <nav className="fixed bottom-0 left-0 right-0 glass safe-bottom lg:hidden z-50">
      <div className="flex items-center justify-around h-16">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-touch p-2 transition-all duration-200 relative ${
                isActive ? 'text-neon' : 'text-muted hover:text-zinc-300'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon className="w-5 h-5" strokeWidth={isActive ? 2 : 1.5} />
                <span className="text-[10px] mt-1 font-display font-medium">{label}</span>
                {isActive && (
                  <div className="absolute -top-0 left-1/2 -translate-x-1/2 w-6 h-0.5 bg-neon rounded-full shadow-neon-sm" />
                )}
              </>
            )}
          </NavLink>
        ))}
        <NavLink
          to={session?.user ? '/login' : '/login'}
          className={({ isActive }) =>
            `flex flex-col items-center justify-center min-touch p-2 transition-all duration-200 relative ${
              isActive ? 'text-neon' : 'text-muted hover:text-zinc-300'
            }`
          }
        >
          {({ isActive }) => (
            <>
              {session?.user ? (
                <User className="w-5 h-5" strokeWidth={isActive ? 2 : 1.5} />
              ) : (
                <LogIn className="w-5 h-5" strokeWidth={isActive ? 2 : 1.5} />
              )}
              <span className="text-[10px] mt-1 font-display font-medium">
                {session?.user ? session.user.name.split(' ')[0] : 'Login'}
              </span>
              {isActive && (
                <div className="absolute -top-0 left-1/2 -translate-x-1/2 w-6 h-0.5 bg-neon rounded-full shadow-neon-sm" />
              )}
            </>
          )}
        </NavLink>
      </div>
    </nav>
  );
}
